import { render, staticRenderFns } from "./editEvent.vue?vue&type=template&id=51df18e8&scoped=true&"
import script from "./editEvent.vue?vue&type=script&lang=js&"
export * from "./editEvent.vue?vue&type=script&lang=js&"
import style0 from "./editEvent.vue?vue&type=style&index=0&id=51df18e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51df18e8",
  null
  
)

export default component.exports